import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

import MainTable from './main-table';
import CustomAppBar from 'Components/CustomAppBar';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    }
}));

export default function FullscreenTable(props) {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <CustomAppBar
                backgroundColor="white"
                addBottomBorder={true}
                third={true}
                nosearch
            >
            </CustomAppBar>
            <MainTable fullscreen={true} />
        </div>
    )
}